import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {Diamonds} from '../Components/Diamonds';
import {BulletLine} from '../Components/BulletLine';
import {CloseX} from '../Components/CloseX';
import {browserHistory} from 'react-router';
import * as Request from '../tgccRequest';

const screenStyle: React.CSSProperties = {
    position: 'absolute',
    top: '18%',
    left: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    marginLeft:'-200px',
    '@media (max-width:414px)': {
        top:'22%'
    },
    '@media (max-width:360px)': {
        top:'22%'
    },
    '@media (max-width:320px)': {
        top:'22%'
    }
}

const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    width: '400px',
    background: 'white',
    padding: '0 20px 5px 20px',
    alignSelf: 'center',
    boxShadow: Tgcc.Styles.boxShadow,
    height:'550px'
}

const contentStyle: React.CSSProperties = {
    border: Tgcc.Styles.singleBorder,
    padding: '10px',
    textAlign: 'center',
    overflow: 'hidden'
}

const woStyle: React.CSSProperties = {
    alignSelf: 'center',
    fontSize: '35px',
    letterSpacing: '12px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)',
    textAlign: 'center',
    margin: '8px 0 0 0',
    fontFamily:'BarlowMedium',
    '@media (max-width:320px)': {
        fontSize:'16px'
    }
}

const statusStyle: React.CSSProperties = {
    alignSelf: 'center',
    fontSize: '18px',
    letterSpacing: '4px',
    fontWeight: 100,
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.7)',
    fontFamily:'BarlowMedium',
    '@media (max-width:320px)': {
        fontSize:'12px'
    }
    
}

const imgStyle: React.CSSProperties = {
    width: 'auto',
    height: 'auto',
    maxWidth: '285px',
    maxHeight: '365px',
    position: 'relative',
    alignSelf: 'center'
}

const btnStyle: React.CSSProperties = {
    display: 'flex',
    backgroundColor: '#5E6A74',
    margin: '8px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'none'
};
const btnText: React.CSSProperties = {
    margin: '5px 10px',
    textTransform: 'uppercase',
    color: 'white',
    fontFamily: 'BarlowMedium',
    fontSize: '12px',
    letterSpacing: '3px',
    padding: '0',
    textAlign: 'center',
    '@media (max-width:414px)': { fontSize:'10px' }
}
const footerStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-around'
}

class _RealCampusProofPopup extends React.Component<Tgcc.BaseProps, any>{

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    canReviseProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status && proof.csrEmail){
            switch(proof.status.toString().toUpperCase()){
                case 'CHANGES':
                case 'EMAILED':
                case 'MISSING':
                case 'M-PROOF':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }


    canApproveProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'EMAILED':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    approveProof = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.RealCampusProofView(this.props.state.ProofPopup.proofId));
    }
    reviseProof = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.RealCampusProofRevise(this.props.state.ProofPopup.proofId));
    }

    reorder = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
    }

    doClose = () => {
        this.props.dispatch({type: Tgcc.StateAction.ProofPopup, payload: null});
    }

    viewRoster = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.RealCampusProofRoster(this.props.state.ProofPopup.proofId));
    }

    
    doTracking = (evt: React.MouseEvent<HTMLDivElement>, tracking: string) =>{
        evt.stopPropagation();
        window.open("https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=" + tracking, "tgcctracking");
    }

    render(){
        var proof: Tgcc.Proof = this.props.state.ProofPopup || new Tgcc.Proof;
        var imgPath = proof? Tgcc.getProofPath(proof.proofId) : Tgcc.Styles.missingProofImageSrc;
                    
        var canRevise = this.canReviseProof(proof);
        var canViewRoster = (proof && (proof.rosterCodes && proof.rosterCodes.length));
        var canApprove = this.canApproveProof(proof);
        var changeBtn = proof && canRevise ? <div className="hoverBorder" style={btnStyle} onClick={this.reviseProof}><div style={btnText}>make changes</div></div> : null;
        var approveBtn = proof && canApprove ? <div className="hoverBorder" style={btnStyle} onClick={this.approveProof}><div style={btnText}>full screen</div></div>  : null;
        var viewRosterBtn = proof && canViewRoster ? <div className="hoverBorder" style={btnStyle} onClick={this.viewRoster}><div style={btnText}>view roster</div></div> : null;

        var trackStyle = Object.assign({}, statusStyle, {textDecoration: 'underline', cursor: 'pointer'});
        var tracking = proof && proof.tracking ? 
            <div style={trackStyle} onClick={ (evt) => this.doTracking(evt, proof.tracking)}>Tracking: {proof.tracking}</div> 
            : null;
               
        return (
            <div style={screenStyle} >
                <div style={wrapperStyle} >
                    <CloseX closeAction={this.doClose}/>
                    <div style={woStyle}>{proof.proofId}</div>
                    <div style={contentStyle}>
                        <img style={imgStyle} src={imgPath} onError={this.onError} />
                        <div style={statusStyle}>Order Status: {proof.status}</div>
                        <div style={statusStyle}>Date: {proof.statusDate}</div>
                        {tracking}
                    </div>
                    <div style={footerStyle}>
                        {approveBtn}
                        {changeBtn}
                        {viewRosterBtn}
                    </div>
                 </div>
            </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { 
        state: state
    }
};

export var RealCampusProofPopup = connect(mapStateToProps)(Radium(_RealCampusProofPopup));